import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropzoneModule } from '../directives/dropzone/dropzone.module';
import { TranslationComponent } from './translation.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { TranslationFileComponent } from './translation-file/translation-file.component';
import { TranslationTextComponent } from './translation-text/translation-text.component';


@NgModule({
  declarations: [
    TranslationComponent,
    TranslationFileComponent,
    TranslationTextComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxJsonViewerModule,
    DropzoneModule
  ],
  exports: [
    TranslationComponent
  ]
})
export class TranslationModule { }